import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { api } from "./api";
import { parseJWT } from "./utils/jwtUtils";

import BetAmountPage from "./pages/BetAmountPage";
import SelectCardsPage from "./pages/SelectCardsPage";
import ConfirmCardPage from "./pages/ConfirmCardPage";
import BetHistory from "./pages/BetHistory";
import BingoGame from "./pages/BingoGame";
import HowToPlay from "./pages/HowToPlay";
import ReferralIncome from "./pages/ReferralIncome";

import WalletPage from "./pages/WalletPage";
import ProfilePage from "./pages/ProfilePage";
import UpdateProfile from "./pages/UpdateProfile";
import Invoice from "./pages/Invoicer";
import LeaderBoard from "./pages/LeaderBoard";
import AdminDashboard from "./pages/AdminDashboard/AdminDashboard";
import UpdateUser from "./pages/AdminDashboard/UpdateUser";
import Home from "./pages/HomePage";

import LoadingPage from "./pages/LoadingPage";
import AdminRoute from "./components/AdminRoute";
import KenoGame from "./pages/KenoComponent/KenoGame";

function App() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const navigate = useNavigate();
  const location = useLocation();

  const authStarted = useRef(false);

  useEffect(() => {
    if (authStarted.current) return;
    authStarted.current = true;

    const authenticate = async () => {
      try {
        const stored = localStorage.getItem("userInfo");

        // Already logged in
        if (stored) {
          const parsed = JSON.parse(stored);
          const userInfo = parseJWT(parsed.token);

          if (userInfo) {
            if (
              location.pathname === "/" &&
              (userInfo.role === "admin" || userInfo.role === "super_admin")
            ) {
              navigate("/admin-page", { replace: true });
            }

            setLoading(false);
            return;
          }

          localStorage.removeItem("userInfo");
        }

        // Telegram auth
        const tg = window.Telegram?.WebApp;

        if (!tg?.initData) {
          setError("Please open this app inside Telegram.");
          setLoading(false);
          return;
        }

        tg.ready();
        tg.expand();

        const res = await api.post("/telegram-auth", {
          initData: tg.initData,
        });

        const token = res.data?.token;

        if (!token) {
          setError("Authentication failed.");
          setLoading(false);
          return;
        }

        const userInfo = parseJWT(token);

        if (!userInfo) {
          setError("Invalid authentication token.");
          setLoading(false);
          return;
        }

        localStorage.setItem(
          "userInfo",
          JSON.stringify({
            token,
            user: userInfo,
          }),
        );

        if (userInfo.role === "admin" || userInfo.role === "super_admin") {
          navigate("/admin-page", { replace: true });
        }

        setLoading(false);
      } catch (err) {
        console.error("AUTH ERROR:", err);

        setError(
          err.response?.data?.message || err.message || "Authentication failed",
        );

        setLoading(false);
      }
    };

    authenticate();
  }, [navigate, location.pathname]);

  if (loading) {
    return <LoadingPage />;
  }

  if (error) {
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <h3>{error}</h3>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/betamountpage" element={<BetAmountPage />} />
      <Route path="/select-cards" element={<SelectCardsPage />} />
      <Route path="/confirm/:id" element={<ConfirmCardPage />} />
      <Route path="/play" element={<BingoGame />} />
      <Route path="/history" element={<BetHistory />} />
      <Route path="/wallet" element={<WalletPage />} />
      <Route path="/HowToWin" element={<HowToPlay />} />
      <Route path="/referralIncome" element={<ReferralIncome />} />
      <Route path="/profile" element={<ProfilePage />} />
      <Route path="/profile-update" element={<UpdateProfile />} />
      <Route path="/invoice" element={<Invoice />} />
      <Route path="/leaderboard" element={<LeaderBoard />} />
      <Route
        path="/admin-page"
        element={
          <AdminRoute>
            <AdminDashboard />
          </AdminRoute>
        }
      />

      <Route
        path="/users/:id"
        element={
          <AdminRoute>
            <UpdateUser />
          </AdminRoute>
        }
      />
      <Route path="/keno-game" element={<KenoGame />} />
    </Routes>
  );
}

export default App;
